import { render, staticRenderFns } from "./MultiCoreDataDetail.vue?vue&type=template&id=f71567e6&scoped=true"
import script from "./MultiCoreDataDetail.vue?vue&type=script&lang=ts"
export * from "./MultiCoreDataDetail.vue?vue&type=script&lang=ts"
import style0 from "./MultiCoreDataDetail.vue?vue&type=style&index=0&id=f71567e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71567e6",
  null
  
)

export default component.exports